module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q4QBJJ.52981bdc.jpg";